import React from "react";
import clsx from "clsx";
import { toast } from "react-toastify";

import IcnCancel from "@assets/icons/rounded/cancel-fill.svg";
import IcnCheckCircle from "@assets/icons/rounded/check_circle-fill.svg";
import { IconComponent } from "@app/core";

import styles from "./default-toast.module.scss";

export const showToast = ({ title, description, iconType }: IToastContentProps) => {
  toast(<ToastContent title={title} description={description} iconType={iconType} />);
};

interface IToastContentProps {
  title: string;
  description?: string;
  iconType?: "success" | "error";
}

const ToastContent = ({ title, description, iconType }: IToastContentProps) => {
  return (
    <div className={clsx(styles.root, styles[iconType || ""])}>
      {iconType && (
        <IconComponent className={styles.icon} icon={iconType === "success" ? IcnCheckCircle : IcnCancel} size="24px" />
      )}
      <div className={styles.text}>
        <h4>{title}</h4>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
};
